import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  deviceIsMobile,
  lang,
  permissions,
  remCss,
  scssVariables,
  setRouter,
  useScreenDetail
} from 'src/helpers';
import FooterInfo from 'src/components/FooterInfo';
import { MCButton, MCError, MCText, Spinner, ToggleSwitch, View } from 'src/components/basic';
import AuthContainer from 'src/components/AuthContainer';
import LANG_CONST from 'src/helpers/lang/const';
import model from './model';
import { BASE_ICONS } from 'src/components/svg';
import errorDescriptions from 'src/constants/errors';

const Subscription = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const screen = useScreenDetail();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [data, setData] = useState({});

  useEffect(() => {
    setRouter({
      location,
      navigate
    });

    if (model.isLogged && !deviceIsMobile) {
      return navigate(permissions.PAGES.SETTING_SECURITY_PAGE.path);
    }

    model.accountDetailById(new URLSearchParams(location.search).get('id'), (error, data) => {
      if (!error && data?.email) {
        setData({ ...data });
        setLoading(false);
      } else {
        setError(errorDescriptions({ status: 404 }));
        setLoading(false);
      }
    });
  }, [location, navigate]);

  return (
    <View style={{ minHeight: '100%' }}>
      <AuthContainer
        style={{ flex: 1, height: 'auto' }}
        enableHomeLeft={false}
        enableFooter={false}
      >
        {loading ? (
          <div className={'mc-m-auto'}>
            <Spinner />
          </div>
        ) : error ? (
          <div className={'mc-container-content'}>
            <div className={'mc-m-auto mc-flex-20-col'}>
              <MCError error={error} mcTextProps={{ style: { textAlign: 'center' } }} />
              <MCButton
                iconname={BASE_ICONS.BACK_ARROW}
                label={LANG_CONST.buttons.back_to_app}
                primary
                transparent
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/');
                }}
              />
            </div>
          </div>
        ) : (
          <View
            className={'mc-page-auth-box'}
            style={{
              gap: remCss(20),
              paddingBottom: remCss(screen.isSmallScreen ? 30 : 50),
              paddingHorizontal: remCss(screen.isSmallScreen ? 30 : 50)
            }}
          >
            <MCText
              size={20}
              weight={400}
              label={LANG_CONST.text.edit_subscription_title}
              style={{ textAlign: 'center', paddingTop: remCss(5) }}
            />
            <div />
            <View style={{ gap: remCss(25) }}>
              <MCText size={20} weight={400}>
                {lang.t(LANG_CONST.for_txt)}{' '}
                <span style={{ color: scssVariables['colors-mc-primary'] }}>{data?.email}</span>
              </MCText>
              <div className={'mc-flex-30'}>
                <MCText label={LANG_CONST.email_news} size={20} />
                <ToggleSwitch
                  checked={data?.email_subscription !== false}
                  onChange={(e) => {
                    e.preventDefault();
                    let email_subscription = data?.email_subscription !== false;
                    email_subscription = !email_subscription;

                    model.emailSubscription(
                      new URLSearchParams(location.search).get('id'),
                      email_subscription,
                      (error) => {
                        if (!error) {
                          setData((o) => ({ ...o, email_subscription }));
                        }
                      }
                    );
                  }}
                />
              </div>
              <MCText size={20} weight={400}>
                {LANG_CONST.text.edit_subscription_des}
              </MCText>
              <div />
              <div />
            </View>
          </View>
        )}
      </AuthContainer>
      {screen.isLargeScreen && <FooterInfo />}
    </View>
  );
};


Subscription.displayName = 'Subscription';

export default Subscription;
